import { setRangeMin } from './helpers';

export const setLandAreaMin = setRangeMin('site');
